export const getLocaleSufix = (locale?: string) => {
  return locale === 'en' ? '' : `/${locale}`;
};
